import { useEffect, useState } from 'react'
import SidebarItems from '../SideBarItems'

import { SidebarContainer, SidebarWrapper } from './styles'

// const MOBILE_VIEW = window.innerWidth < 468

const Sidebar: React.FC = () => {
  const [displaySidebar, setDisplaySidebar] = useState(true)

  useEffect(() => {
    if (window.innerWidth > 468) {
      setDisplaySidebar(!displaySidebar)
    } else {
      setDisplaySidebar(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setDisplaySidebar])

  return (
    <SidebarContainer displaySidebar={displaySidebar}>
      <SidebarWrapper>
        {/* 
        TODO: Fazer a lógica para ter um botão apenas no mobile
        <SidebarToggler
              displaySidebar={displaySidebar}
              onClick={handleSidebarDisplay}
            >
              <div className="outer__circle">
                <div className="inner__circle" />
              </div>
            </SidebarToggler> */}
        <SidebarItems displaySidebar={displaySidebar} />
      </SidebarWrapper>
    </SidebarContainer>
  )
}

export default Sidebar
